if (!customElements.get('mathilda-header')) {
  customElements.define('mathilda-header', class MathildaHeader extends HTMLElement {
    connectedCallback() {
      this._drawer      = document.querySelector('[data-mathilda-drawer]');
      this._header      = document.querySelector('.header');
      this._openBtns    = document.querySelectorAll('[data-mathilda-mobile-open]');

      if (!this._drawer) return;

      this._overlay     = this._drawer.querySelector('[data-mathilda-drawer-overlay]');
      this._closeBtn    = this._drawer.querySelector('[data-mathilda-drawer-close]');
      this._tabs        = this._drawer.querySelectorAll('[data-mathilda-tab]');
      this._panes       = this._drawer.querySelectorAll('[data-mathilda-pane]');
      this._subTriggers = this._drawer.querySelectorAll('[data-mathilda-sub-trigger]');

      this._initDrawer();
      this._initScroll();
      this._initTabDrag();
    }

    // ─── DRAWER ───────────────────────────────────────────────────────────────

    _openDrawer(handle) {
      this._drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      this._tabs.forEach(t => {
        t.classList.toggle('is-active', t.getAttribute('data-mathilda-tab') === handle);
      });
      this._panes.forEach(p => {
        const active = p.getAttribute('data-mathilda-pane') === handle;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    _closeDrawer() {
      this._drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this._tabs.forEach(t => t.classList.remove('is-active'));
      this._panes.forEach(p => {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
    }

    _initDrawer() {
      // Hamburger / open butonları
      this._openBtns.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (this._drawer.getAttribute('aria-hidden') === 'false') {
            this._closeDrawer();
            return;
          }
          const firstTab = this._drawer.querySelector('[data-mathilda-tab]');
          if (firstTab) {
            this._openDrawer(firstTab.getAttribute('data-mathilda-tab'));
          } else {
            this._drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        });
      });

      // Tab tıklamaları
      this._tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const h = tab.getAttribute('data-mathilda-tab');
          if (h) this._openDrawer(h);
        });
      });

      // Kapatma
      this._closeBtn?.addEventListener('click', () => this._closeDrawer());
      this._overlay?.addEventListener('click',  () => this._closeDrawer());
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this._closeDrawer();
      });

      // Sub-menu accordion
      this._subTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const list = trigger.nextElementSibling;
          if (!list) return;
          const open = list.classList.contains('is-open');
          trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          list.classList.toggle('is-open', !open);
        });
      });

      // Link tıklamasında drawer kapat
      this._drawer.querySelectorAll('a[href]').forEach(a => {
        a.addEventListener('click', () => this._closeDrawer());
      });
    }

    // ─── STICKY / TRANSPARENT SCROLL ─────────────────────────────────────────

    _initScroll() {
      if (!this._header) return;

      const isSticky      = this._header.dataset.enableStickyHeader === 'true';
      const transHome     = document.body.classList.contains('header-transparent-on-home');
      const transCol      = document.body.classList.contains('header-transparent-on-collection');
      const isHome        = window.location.pathname === '/';
      const isCollection  = window.location.pathname.startsWith('/collections');

      // Sticky header offset
      if (isSticky) {
        const updateHeight = () => {
          const section = document.querySelector('#shopify-section-header');
          if (section) {
            document.documentElement.style.setProperty('--height-header', section.offsetHeight + 'px');
          }
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);
      }

      // Transparent toggle
      const shouldHandleTransparent = (transHome && isHome) || (transCol && isCollection);
      if (!shouldHandleTransparent) return;

      const onScroll = () => {
        if (window.scrollY > 10) {
          this._header.classList.remove('header--transparent');
        } else {
          this._header.classList.add('header--transparent');
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // ilk render için
    }

    // ─── TAB BAR DRAG SCROLL ─────────────────────────────────────────────────

    _initTabDrag() {
      const tabBar = this._drawer.querySelector('.mathilda-drawer__tabs');
      if (!tabBar) return;

      let isDragging = false, startX = 0, scrollLeft = 0;

      tabBar.addEventListener('mousedown', e => {
        isDragging = true;
        startX     = e.pageX - tabBar.offsetLeft;
        scrollLeft = tabBar.scrollLeft;
      });
      tabBar.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
        tabBar.scrollLeft = scrollLeft - (e.pageX - tabBar.offsetLeft - startX);
      });
      ['mouseup', 'mouseleave'].forEach(ev => {
        tabBar.addEventListener(ev, () => { isDragging = false; });
      });
    }
  });
}